export const SURVEY_CODE = {
  LATEST_QOL_SURVEY_LINK_ID: '4.1',
  MED_ADHERENCE: 'MED_ADHERENCE', // Medication Adherence Survey
  QOL_EQ5D5L: 'QOL_EQ5D5L', // EQ-5D-5L Quality of Life Survey
};

// #region THERAPY DATA Coding
const medicalCodes = {
  HTN_MED_STATUS: 'htn_med_status', // HTN medication status
};

export const bloodPressureGeneralCodes = {
  BP_PANEL_AT_ENROLL: 'BP_Panel_at_enroll', // Blood Pressure Panel at Enroll
  SYSTOLIC_BP_TARGET: 'SystolicBP_target', // Target Systolic Blood Pressure
  SYSTOLIC_BP_AT_ENROLL: 'SystolicBP_at_enroll', // Systolic Blood Pressure at Enroll
  DIASTOLIC_BP_TARGET: 'DiastolicBP_target', // Target Diastolic Blood Pressure
  DIASTOLIC_BP_AT_ENROLL: 'DiastolicBP_at_enroll', // Diastolic Blood Pressure at Enroll
  CHOLESTEROL_TOTAL: 'Cholesterol_total', // Total cholesterol
  CHOLESTEROL_HDL: 'Cholesterol_HDL', // High Density Lipoprotein Cholesterol
  CHOLESTEROL_LDL: 'Cholesterol_LDL', // Low Density Lipoprotein Cholesterol
  HEIGHT_IN: 'Height_in', // Height in inches
  WEIGHT_LB: 'Weight_lb', // Weight in pounds
  DATE_OF_CHOLESTEROL_LAB_DRAW: 'Date_of_Cholesterol_Lab_Draw',
  DATE_OF_OFFICE_VISIT: 'Date_of_Office_Visit',
};

const bloodPressureCodes = {
  BP_PANEL: 'BP_Panel', // Systolic and Diastolic Pressure in mmHg
  SYSTOLIC_BP: 'SystolicBP', // Systolic Blood Pressure in mmHg
  DIASTOLIC_BP: 'DiastolicBP', // Diastolic Blood Pressure in mmHg
  HEART_RATE_BP: 'HEART_RATE_BP', // Heart rate (collected while measuring withings blood pressure)
};

export const rdnTimelineCodes = {
  HTN_DX_DURATION_ENROLL: 'HTN_Dx_DURATION_ENROLL', // Approximate Time of HTN Diagnosis
  HTN_LEVEL_OF_CONCERN: 'HTN_LEVEL_OF_CONCERN',
  RDN_CONS_COMP: 'RDN_CONS_COMP', // RDN Consultation complete
  RDN_CONS_COMP_DATE: 'RDN_CONS_COMP_DATE', // RDN Consultation complete date
  RDN_CONS_SCHED: 'RDN_CONS_SCHED', // RDN Consultation scheduled
  RDN_CONS_SCHED_DECLINE_REASONS: 'RDN_CONS_SCHED_DECLINE_REASONS', // RDN Consultation declined
  RDN_PA_CONF: 'RDN_PA_CONF', // RDN prior authorization confirmed
  RDN_REFERRED_IC: 'RDN_REFERRED_IC', // Referred to Interventional Cardiologist
  RDN_PROC_COMP: 'RDN_PROC_COMP', // RDN Procedure complete
  RDN_POST_PROC_MONITOR_BY_PROCEDURALIST: 'RDN_POST_PROC_MONITOR_BY_PROCEDURALIST', // RDN Consultation is monitoring by proceduralist
  RDN_DISCHARGED_BY_PROCEDURALIST: 'RDN_DISCHARGED_BY_PROCEDURALIST', // RDN Consultation discharged by proceduralist
  RDN_PROC_COMP_DATE: 'RDN_PROC_COMP_DATE', // RDN Procedure complete date
  RDN_PROC_SCHED: 'RDN_PROC_SCHED', // RDN Procedure scheduled
  RDN_PROC_SCHED_DATE: 'RDN_PROC_SCHED_DATE', // RDN Procedure scheduled date
  RDN_PROCEDURALIST_EVAL: 'RDN_PROCEDURALIST_EVAL', // Has Patient been evaluated by proceduralist for RDN,
  RDN_PROCEDURALIST_REFER: 'RDN_PROCEDURALIST_REFER', // Has the patient ever been referred to a proceduralist for RDN consultation,
  RDN_PROCEDURALIST_REFER_NAME: 'RDN_PROCEDURALIST_REFER_NAME', // Which Proceduralist Performed RDN for the patient (free text entry),
  RDN_PROCEDURALIST_REFER_NPI: 'RDN_PROCEDURALIST_REFER_NPI', // Which Proceduralist have they been referred to (NPI),
  RDN_PROCEDURALIST_PERFORM_NAME: 'RDN_PROCEDURALIST_PERFORM_NAME', // Which Proceduralist Performed RDN for the patient (free text entry),
  RDN_PROCEDURALIST_PERFORM_NPI: 'RDN_PROCEDURALIST_PERFORM_NPI', // Which Proceduralist Performed RDN for the patient (NPI),
  RDN_PROC_PRODUCT_USED: 'RDN_PROC_PRODUCT_USED', // If RDN performed, which product was used
};

export const stepsToRuleOutSecondaryHtnCodes = {
  SECONDARY_HTN_DIFFERENTIAL_SLEEP: 'Secondary_HTN_Differential_Sleep', // Secondary HTN Sleep Study
  SECONDARY_HTN_DIFFERENTIAL_BCP: 'Secondary_HTN_Differential_BCP', // Secondary HTN Blood Chemistry Profile
  SECONDARY_HTN_DIFFERENTIAL_ECG12: 'Secondary_HTN_Differential_ECG12', // Secondary HTN ECG 12 Lead
  SECONDARY_HTN_DIFFERENTIAL_UA: 'Secondary_HTN_Differential_UA', // Secondary HTN UA
  SECONDARY_HTN_DIFFERENTIAL_CBC: 'Secondary_HTN_Differential_CBC', // Secondary HTN complete blood count
};

export const THERAPY_DATA_CODE = {
  ...medicalCodes,
  ...bloodPressureGeneralCodes,
  ...bloodPressureCodes,
  ...rdnTimelineCodes,
  ...stepsToRuleOutSecondaryHtnCodes,
  HTN_REASON_ENROLL: 'HTN_Reason_Enroll', // Suspected reason for enrolling patient
  // LAST_REVIEWED: 'LastReviewed', // Time when provider marks a patient in patient list as "reviewed" or "snooze"
  // BP_CONCERN_LEVEL: 'BP_CONCERN_LEVEL', // Blood pressure level of concern
  BODY_MASS_INDEX: 'BMI',
};
// #endregion

// #region MEDICAL HISTORY AND CONDITIONS Coding
export const generalHTNDiagnosis = {
  HTN_DIAGNOSED: 'HTN_Diagnosed', // Diagnosed with Hypertension ('HTN')
  HTN_NOT_DIAGNOSED: 'HTN_Not_Diagnosed', // Not diagnosed with HTN
};

export const htnDiagnosisCodes = {
  HTN_PRIMARY_STG_1: 'HTN_Primary_Stg_1', // Primary HTN Stage 1
  HTN_PRIMARY_STG_2: 'HTN_Primary_Stg_2', // Primary HTN Stage 2
  HTN_SECONDARY: 'HTN_Secondary', // Secondary HTN
  HTN_WHITE_COAT: 'HTN_White_Coat', // White Coat HTN
  HTN_MASKED: 'HTN_Masked', // Masked HTN
};

export const patientMHCOptions = {
  DIABETES_HISTORY: 'Diabetes_History', // Diabetes history
  SMOKING_CURRENT: 'Smoking_Current', // Current smoker
  SMOKING_HISTORY: 'Smoking_History', // Smoking history
  OSA_HISTORY: 'OSA_History', // Obstructive Sleep Apnea History
  CAD_MI_HISTORY: 'CAD_MI_History', // Coronary Artery Disease or Heart Attack history
  STROKE_TIA_HISTORY: 'Stroke_TIA_History', // Stroke TIA history
  REDUCED_KIDNEY_HISTORY: 'Reduced_Kidney_History', // Reduced kidney function history
  HF_HISTORY: 'HF_History', // Heart failure history
};

export const generalHTNDisorderHistory = {
  HTN_DISORDER_HX: 'HTN_Disorder_Hx', // HTN disorder history
  HTN_DISORDER_NO_HX: 'HTN_Disorder_No_Hx', // No HTN disorder history
};

// Not in the bulk search API yet
export const specificHTNDisorderHistory = {
  GESTATIONAL: 'Gestational', // Gestational HTN
  PREECLAMPSIA: 'Preeclampsia', // Preeclampsia
  ECLAMPSIA: 'Eclampsia', // Eclampsia
  HELP_SYNDROME: 'HELP_Syndrome', // HELP Syndrome
};

// Not in the bulk search API yet
export const secondaryHTNCauses = {
  // Secondary Causes of HTN
  RENAL_PARENCHYMAL_DISEASE: 'Renal_Parenchymal_Disease', // Renal parenchymal disease
  RENOVASCULAR_DISEASE: 'Renovascular_Disease', // Renovascular disease
  PRIMARY_ALDOSTERONISM: 'Primary_Aldosteronism', // Primary aldosteronism
  OSA: 'OSA', // Obstructive sleep apnea
  DRUG_ALCOHOL_INDUCED_SECONDARY_HTN: 'Drug_Alcohol_Induced_Secondary_HTN', // Drug or alcohol induced Secondary HTN
  PPGL: 'PPGL', // Pheochromocytoma/paraganglioma
  CUSHINGS_SYNDROME: 'Cushings_Syndrome', // Cushing's Syndrome
  HYPOTHYROIDISM: 'Hypothyroidism', // Hypothyroidism
  HYPERTHYROIDISM: 'Hyperthyroidism', // Hyperthyroidism
  COA_NO_DX_REPAIR: 'COA_No_Dx_Repair', // Aortic coarctation (undiagnosed or repaired)
  PHPT: 'PHPT', // Primary hyperparathyroidism
  CAH: 'CAH', // Congenital adrenal hyperplasia
  MES_NOT_PRIMARY_ALDOSTERONISM: 'MES_Not_Primary_Aldosteronism', // Mineralocorticoid excess syndromes other than primary aldosteronism
  ACROMEGALY: 'Acromegaly', // Acromegaly
};

export const MHC_CODE = {
  ...generalHTNDiagnosis,
  ...htnDiagnosisCodes,
  ...patientMHCOptions,
  ...generalHTNDisorderHistory,
  ...specificHTNDisorderHistory,
  ...secondaryHTNCauses,
};

// #endregion

export const PATIENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const CARE_PATHWAYS = {
  NOT_DIAGNOSED: 'N/A - Not diagnosed with hypertension',
  LIFESTYLE_ONLY: 'Lifestyle modification only',
  MED_MANAGEMENT: 'Medical management',
  CONSIDER_RDN_MM: 'Under consideration for RDN: medical management',
  CONSIDER_RDN_LIFESTYLE: 'Under consideration for RDN: lifestyle modification only',
  POST_RDN_MM: 'Post-RDN: medical management',
  POST_RDN_LIFESTYLE: 'Post-RDN: lifestyle modification only',
};

export const RDN_CARE_PATHWAYS = [
  CARE_PATHWAYS.CONSIDER_RDN_MM,
  CARE_PATHWAYS.CONSIDER_RDN_LIFESTYLE,
  CARE_PATHWAYS.POST_RDN_MM,
  CARE_PATHWAYS.POST_RDN_LIFESTYLE,
];

export const CAN_CREATE_REFERRAL_FORM_MAP = {
  [CARE_PATHWAYS.LIFESTYLE_ONLY]: true,
  [CARE_PATHWAYS.MED_MANAGEMENT]: true,
  [CARE_PATHWAYS.CONSIDER_RDN_MM]: true,
  [CARE_PATHWAYS.CONSIDER_RDN_LIFESTYLE]: true,
};

export const CAN_VIEW_REFERRAL_FORM_MAP = {
  [CARE_PATHWAYS.CONSIDER_RDN_MM]: true,
  [CARE_PATHWAYS.CONSIDER_RDN_LIFESTYLE]: true,
};
